
const state = {
  id: null,
  notes: '',
}

export const requiredFields = []

export default state
